export enum ProductVersionColumns {
    checklistVersion = 'Checklist version',
    directory = 'Directory',
    name = 'Name',
    priceListVersion = 'Pricelist version',
    updatedAt = 'Updated at',
    hasError = 'Has error',
    commodityGroup = 'Commodity group',
    matchCode = 'Matchcode',
    priceOne = 'Price 1',
    priceTwo = 'Price 2',
    productGroup = 'Product group',
}
